import React from "react"
import { InputTextFloatLabel } from "~components/input-text"

interface Props {
  value: string
  placeholder?: string
  onChange: (value: string) => void
}

const ConfirmPassword: React.FC<Props> = ({ value, onChange, ...rest }) => (
  <InputTextFloatLabel
    label="再次确认密码"
    secureTextEntry={true}
    keyboardType={"ascii-capable"}
    placeholder={"请输入相同密码"}
    value={value}
    onChangeText={onChange}
    {...rest}
  />
)

export default ConfirmPassword
